import React from 'react';

const UserAvatar = () => {
    return (
        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_i_3831_30988)">
                <g clipPath="url(#clip0_3831_30988)">
                    <rect x="6" y="6" width="40" height="40" rx="20" fill="#C0EAED" />
                    <path opacity="0.5" d="M19.7895 26.6316C19.7895 31.2632 21.0526 35.6842 24 46C12.9543 46 4 37.0457 4 26C4 14.9543 12.9543 6 24 6C19.3684 17.5789 19.7895 22 19.7895 26.6316Z" fill="#98DDE1" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M31.2575 15.344C32.7039 16.7904 33.5999 18.7904 33.5999 21C33.5999 23.2096 32.7039 25.2096 31.2575 26.656C29.8095 28.104 27.8095 29 25.5999 29C23.3903 29 21.3903 28.104 19.9423 26.656C18.4959 25.2096 17.5999 23.2096 17.5999 21C17.5999 18.7904 18.4959 16.7904 19.9423 15.344C21.3903 13.896 23.3903 13 25.5999 13C27.8095 13 29.8095 13.896 31.2575 15.344ZM25.8 46.8C16.425 46.8 10.8 44.3333 10.8 41.8667C10.8 36.9333 16.425 32 25.8 32C34.915 32 40.8 36.9333 40.8 41.8667C40.8 44.3333 34.595 46.8 25.8 46.8Z" fill="#7B93AF" />
                </g>
            </g>
            <rect x="0.5" y="0.5" width="51" height="51" rx="25.5" stroke="#98DDE1" />
            <defs>
                <filter id="filter0_i_3831_30988" x="6" y="6" width="40" height="40" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3831_30988" />
                </filter>
                <clipPath id="clip0_3831_30988">
                    <rect x="6" y="6" width="40" height="40" rx="20" fill="white" />
                </clipPath>
            </defs>
        </svg>


    )
}

export default UserAvatar;